var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.13959C13.5 6.6854 13.3185 7.38144 12.991 8.17699C12.6668 8.96456 12.2154 9.81196 11.712 10.6492C10.7057 12.3229 9.51479 13.9185 8.78508 14.8549C8.63298 15.0484 8.36702 15.0484 8.21492 14.8549C7.48521 13.9185 6.29426 12.3229 5.28799 10.6492C4.78464 9.81196 4.33324 8.96456 4.00899 8.17699C3.68146 7.38144 3.5 6.6854 3.5 6.13959C3.5 3.29032 5.75142 1 8.5 1C11.2486 1 13.5 3.29032 13.5 6.13959ZM6.16667 6.13959C6.16667 7.44071 7.20092 8.51946 8.5 8.51946C9.79908 8.51946 10.8333 7.44071 10.8333 6.13959C10.8333 4.83848 9.79908 3.75973 8.5 3.75973C7.20092 3.75973 6.16667 4.83848 6.16667 6.13959Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8f8052b713819a4cff0573c75154adac.svg";
export { ForwardRef as ReactComponent };